import { Suspense } from 'react';
import {
  getDeckLessonDefinition,
  getDeckLessonIds,
  getDeckLessonRoute,
} from './lessons/registry';

function getLessonParam(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get('lesson');
}

export default function DeckApp() {
  const lesson = getLessonParam();
  const lessonDefinition = lesson ? getDeckLessonDefinition(lesson) : null;
  const availableLessonIds = getDeckLessonIds();
  const LessonComponent = lessonDefinition?.component;

  return (
    <>
      {/* Google Fonts for deck surface */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link
        href="https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@500;600;700;800;900&family=IBM+Plex+Mono:wght@400;500&family=Outfit:wght@300;400;500;600;700&display=swap"
        rel="stylesheet"
      />
      <Suspense
        fallback={
          <div
            style={{
              background: '#0a0a0e',
              color: 'rgba(240,237,232,0.38)',
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: "'Barlow Condensed', sans-serif",
              fontSize: 22,
              letterSpacing: '0.12em',
              textTransform: 'uppercase' as const,
            }}
          >
            Loading deck...
          </div>
        }
      >
        {LessonComponent ? (
          <LessonComponent />
        ) : (
          <div
            style={{
              background: '#0a0a0e',
              color: '#f0ede8',
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: "'Outfit', sans-serif",
              fontSize: 20,
              padding: '0 32px',
              textAlign: 'center',
            }}
          >
            <div>
              No lesson found.
              <div style={{ marginTop: 12 }}>
                Try{' '}
                <code style={{ color: '#FEE500' }}>
                  {getDeckLessonRoute(availableLessonIds[0] ?? 'foundations-01')}
                </code>
              </div>
            </div>
          </div>
        )}
      </Suspense>
    </>
  );
}
